import { ScrollArea } from "@base-ui/react/scroll-area"
import React from "react"
import { useTranslation } from "react-i18next"

import { Button } from "shared/ui/buttons/Button"
import { IconName } from "shared/ui/icon/__generated__/IconName"
import { Tooltip } from "shared/ui/tooltip/Tooltip"

import { AppSidebarViewModel } from "../model/useAppSidebarViewModel"

export const AppSidebarContent = React.memo(
  ({
    menuLinks,
    menuLinksSecondary,
    menuLinksTertiary,
    userDetailsSlot,
    isExpanded = false,
    authAction,
    hideHeader = false,
    onToggleExpanded
  }: AppSidebarViewModel) => {
    const { t } = useTranslation()

    return (
      <div className="app-sidebar__content">
        {!hideHeader ? (
          <>
            <div className="app-sidebar__header">
              <Button
                variant="link"
                icon={isExpanded ? IconName.ARROW_LEFT : IconName.ARROW_RIGHT}
                onClick={onToggleExpanded}
                label={t("Menu.Menu")}
                aria-label={isExpanded ? t("Menu.Collapse") : t("Menu.Expand")}
              />
            </div>
            <div className="divider" />
          </>
        ) : null}

        <nav
          className="app-sidebar__nav"
          aria-label={t("Navigation.SiteNavigation")}
        >
          <ScrollArea.Root className="scroll-area scroll-area--vertical app-sidebar__scroll-area">
            <ScrollArea.Viewport className="scroll-area__viewport">
              <ScrollArea.Content className="scroll-area__content">
                <div className="app-sidebar__links app-sidebar__links--primary">
                  {userDetailsSlot}
                  {menuLinks}
                </div>

                <div className="divider" />

                <div className="app-sidebar__links app-sidebar__links--secondary">
                  {menuLinksSecondary}
                </div>

                <div className="app-sidebar__links app-sidebar__links--tertiary">
                  {menuLinksTertiary}
                  <div className="divider" />
                </div>
              </ScrollArea.Content>
            </ScrollArea.Viewport>
            <ScrollArea.Scrollbar
              orientation="vertical"
              className="scroll-area__scrollbar"
            >
              <ScrollArea.Thumb className="scroll-area__thumb" />
            </ScrollArea.Scrollbar>
          </ScrollArea.Root>
        </nav>

        <div className="app-sidebar__footer">
          <Tooltip placement="right" content={authAction.label}>
            <div className="d-flex flex-grow-1">
              <Button {...authAction} className="btn btn-link" />
            </div>
          </Tooltip>
        </div>
      </div>
    )
  }
)
